module.exports = __webpack_public_path__ + "img/bvlgari.678ff0fc.png";